import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchviewdata, fetchdata, fetchviewDoc, ApplyData } from '../reduxactions/organizationactions/OrgApplyAppActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
export const OrgApplyApplication = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');

  const location = useLocation();

  const [queryParams, setQueryParams] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setQueryParams(params.get("fundman_id") as any);
  }, [location]);
  const { fundman_id } = useParams();
  console.log('Row ID:', fundman_id);
  const dispatch = useDispatch()
  const data = useSelector((state: RootState) => state.orgappapplication.data);
  const viewdata = useSelector((state: RootState) => state.orgappapplication.viewdata);
  const docdata = useSelector((state: RootState) => state.orgappapplication.docdata);
  const applydata = useSelector((state: RootState) => state.orgappapplication.applydata);
  const [value, setValue] = useState('');
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid, fundman_id) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDocDataAsync = async () => {
    try {

      console.log("ids", uid)
      await dispatch(fetchviewDoc(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataViewAsync = async () => {
    try {
      await dispatch(fetchviewdata(uid) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
    fetchDocDataAsync();
    fetchDataViewAsync();

  }, [dispatch]);
  const [allattachments, setAttachments] = useState(false);

  const [appData, setApplyeData] = useState({
    id: '',

  });
  const [description, setDescription] = useState<string>('');

  const navigate = useNavigate();
  const applyApplication = async (response: any) => {

    try {
      await dispatch(ApplyData(uid, fundman_id, description) as any);
      const url = `/oorgapplications`;
      navigate(url);
    } catch (error) {
      console.error('Error applying :', error);
    }

    fetchDataAsync();

  };

  const AddNeedsclose = async () => {
    setAttachments(false);

  }

  const Attachmentslist = () => {

    setAttachments(true);
    fetchDocDataAsync();
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const onSelectionChange = (e: any) => {
    setSelectedRows(e.value);
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/Addorg-applications.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="col-16" style={{ textAlign: "right" }}>
            <a
              title="help"
              onClick={(e) => openWindow(e, IUrl)}
              style={{

                color: "blue",
                fontSize: 15, cursor: "pointer"
              }}
            >Help for this Page &nbsp;
              <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

            </a>
          </div>
          <div className="content-wrapper">
            {viewdata.map((response: any) =>
              <section className="content">
                <div className="grid">
                  <div className="col-1"></div>
                  <div className="col-10">
                    <Card title="" className='border-blue-300 surface-overlay border-3 border-round font-bold m-2' >
                      <Panel header="New Application">
                        <div className="grid">

                          <div className="col-12 md:col-12 lg:col-5">
                            <label ><h3>Name Of The Organization</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.nameoftheorg} />
                            <label ><h3>Name Of The Head</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.nameofthehead} />
                            <label ><h3>Email Address</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.email} />
                            <label ><h3>Phone</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.mobile} />
                            <label ><h3>Licence No.</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.licenseno} />


                          </div>
                          <div className="col-12 md:col-12 lg:col-1"></div>
                          <div className="col-12 md:col-12 lg:col-5">
                            <label ><h3>Website Url</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.website_url} />
                            <label ><h3>Address</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.address} />
                            <label ><h3>Country</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.CountryID} />
                            <label ><h3>Pincode</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.pincode} />
                            <label ><h3>Licence Expire Date</h3></label>
                            <br></br>
                            <InputText id="name" type="text" className="w-full mb-3" value={response.license_expdate} />

                          </div>
                        </div>
                      </Panel>
                    </Card>
                    <Card title="" className='border-blue-300 surface-overlay border-3 border-round font-bold m-2' >
                      <Panel header="Description">
                        <div className="grid">
                          <div className="col-12">
                            <InputTextarea value={description} placeholder="Add Description here..." onChange={(e) => setDescription(e.target.value)} rows={20} cols={70} />

                          </div>
                          <div className="col-10"></div>
                          <div className="col-2">
                            <Button
                              className="btn btn-primary"
                              label="Apply"
                              style={{ float: 'left' }}
                              onClick={() => applyApplication(response)}

                            />
                          </div>

                        </div>
                      </Panel>
                    </Card>

                  </div>

                  <div className="col-1"></div>
                </div>
              </section>
            )}
            <div className="grid">
              <div className="col-1"></div>
              <div className="col-10">
                <Card title="" className='border-blue-300 surface-overlay border-3 border-round font-bold m-2' >

                  <Panel header="Attachments">
                    <div className="grid">

                      <div className="col-10"></div>
                      <div className="col-2">

                        <Button label="Attachments" className="btn btn-primary" onClick={() => Attachmentslist()} />

                      </div>

                      <div className="col-12">

                        <div className="card card-primary">
                          <div className="card flex flex-wrap justify-content">
                            <span className="p-input-icon-left">
                              <i className="pi pi-search" />
                              <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                            </span>
                          </div>
                          <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                            <Column field="doc_name" sortable header="Attachment Name"></Column>
                            <Column field="CreteDate" sortable header="Expiry Date"></Column>
                          </DataTable>

                        </div>
                      </div>
                    </div>
                  </Panel>

                </Card>
              </div>
            </div>
          </div>
          <Dialog header="Add Uploads" breakpoints={{ '960px': '75vw', '641px': '100vw' }} visible={allattachments} style={{ width: '60vw' }} onHide={() => setAttachments(false)} >
            <Panel header="Attachments">
              <div className="grid">
                <div className="col-12">
                  <div className="card card-primary">
                    <div className="card flex flex-wrap justify-content">
                      <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                      </span>
                    </div>

                    <DataTable
                      value={docdata}
                      stripedRows
                      paginator
                      rows={5}
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      tableStyle={{ minWidth: '50rem' }}
                      globalFilter={globalFilter}
                      selectionMode="multiple"
                      selection={selectedRows}
                      onSelectionChange={(e) => setSelectedRows(e.value)}
                    >
                      <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} header="Select"></Column>
                      <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                      <Column field="doc_name" sortable header="Attachment Name"></Column>
                      <Column field="CreteDate" sortable header="Expiry Date"></Column>
                    </DataTable>

                  </div>
                </div>
              </div>
            </Panel>
          </Dialog>
        </div>
      </div>
    </div >
  )
}
export default OrgApplyApplication


